<template>
    <footer id="footer" class="footer-container js-footer">
                <div class="footer-center">
                    <div class="container">
                        <div class="inner">
                            <div class="row ApRow" style>
                                <div
                                    class="col-xl-4 col-lg-3 col-md-12 col-sm-12 col-xs-12 col-sp-12 ApColumn"
                                >
                                    <div class="footer_logo">
                                        <a
                                            href="#"
                                            title="Leo Stationero"
                                        >
                                            <img
                                                class="logo img-fluid"
                                                src="/logo/white.png"
                                                alt="Leo Stationero"
                                                style="height: 50px;"
                                                loading="lazy"
                                            />
                                        </a>
                                    </div>

                                    <div class="block text-footer ApHtml">
                                        <div class="block_content">
                                            <div>
                                                We promise we’ll get back to you
                                                <br />promptly– your gifting
                                                needs are always <br />on our
                                                minds!
                                            </div>
                                        </div>
                                    </div>
                                    <div class="block-social block links">
                                        <ul id="footer_block_social">
                                            <li class="facebook">
                                                <a
                                                    href="https://www.facebook.com/share/1JZ7JR7m2n/"
                                                    title="Facebook"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    ><span>Facebook</span></a
                                                >
                                            </li>
                                            <li class="twitter">
                                                <a
                                                    href="#"
                                                    title="Twitter"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    ><span>Twitter</span></a
                                                >
                                            </li>
                                            <li class="youtube">
                                                <a
                                                    href="#"
                                                    title="YouTube"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    ><span>YouTube</span></a
                                                >
                                            </li>
                                            <li class="instagram">
                                                <a
                                                    href="#"
                                                    title="Instagram"
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    ><span>Instagram</span></a
                                                >
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div
                                    class="col-xl-2 col-lg-3 col-md-4 col-sm-12 col-xs-12 col-sp-12 ApColumn"
                                >
                                    <div class="block ApLink ApBlockLink">
                                        <h4 class="title_block">
                                            Useful Links
                                        </h4>
                                        <ul>
                                            <li>
                                                <a
                                                    href="#"
                                                    target="_self"
                                                    >About Us</a
                                                >
                                            </li>
                                            <li>
                                                <a
                                                    href="/contact"
                                                    target="_self"
                                                    >Contact Us</a
                                                >
                                            </li>
                                            <!-- <li>
                                                <a
                                                    href="#"
                                                    target="_self"
                                                >
                                                    Delivery Policy
                                                </a>
                                            </li> -->
                                            <!-- <li>
                                                <a
                                                    href="#"
                                                    target="_self"
                                                    >FAQ’s
                                                </a>
                                            </li> -->
                                            <li>
                                                <a
                                                    href="/privacy-policy"
                                                    target="_self"
                                                    >Privacy Policy
                                                </a>
                                            </li>
                                            <li>
                                                <a
                                                    href="/return"
                                                    target="_self"
                                                    >Return Policy</a
                                                >
                                            </li>
                                            <li>
                                                <a
                                                    href="/terms-conditions"
                                                    target="_self"
                                                    >Terms & Conditions</a
                                                >
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div
                                    class="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-xs-12 col-sp-12 ApColumn"
                                >
                                    <div class="block ApLink ApBlockLink">
                                        <h4 class="title_block">Shop</h4>
                                        <ul>
                                            <li>
                                                <a href="/products" target="_self"
                                                    >Shop</a
                                                >
                                            </li>
                                            <!-- <li>
                                                <a
                                                    href="#"
                                                    target="_self"
                                                    >Blog News
                                                </a>
                                            </li> -->
                                            <li>
                                                <a
                                                    href="#"
                                                    target="_self"
                                                    >New Arrivals
                                                </a>
                                            </li>
                                            <!-- <li>
                                                <a
                                                    href="#"
                                                    target="_self"
                                                    >Keywords
                                                </a>
                                            </li>
                                            <li>
                                                <a
                                                    href="#"
                                                    target="_self"
                                                    >Sitemap
                                                </a>
                                            </li> -->
                                        </ul>
                                    </div>
                                </div>
                                <div
                                    class="col-xl-3 col-lg-3 col-md-4 col-sm-12 col-xs-12 col-sp-12 ApColumn"
                                >
                                    <div class="block contact-w ApHtml">
                                        <h4 class="title_block">Need Help</h4>
                                        <div class="block_content">
                                            <div>
                                                <span class="icon"
                                                    ><i
                                                        class="fal fa-phone"
                                                    ></i></span
                                                ><a
                                                    href="tel:+8801841464839"
                                                    data-mce-href="tel:+8801841464839"
                                                    >(+880)-1841464839</a
                                                >
                                            </div>
                                            <!-- <div>
                                                <span class="icon"
                                                    ><i
                                                        class="fal fa-clock"
                                                    ></i></span
                                                ><span
                                                    >Monday – Friday:
                                                    9:00-20:00<br />
                                                    Saturday: 11:00 –
                                                    15:00</span
                                                >
                                            </div> -->
                                            <div>
                                                <span class="icon"
                                                    ><i
                                                        class="fal fa-envelope"
                                                    ></i></span
                                                ><a
                                                    href="#"
                                                    data-mce-href="mailto:info.penpencilbd@gmail.com"
                                                    ><span
                                                        class="__cf_email__"
                                                        data-cfemail="info.penpencilbd@gmail.com"
                                                        >info.penpencilbd@gmail.com</span
                                                    ></a
                                                >
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="footer-bottom">
                    <div class="container">
                        <div class="inner">
                            <div class="row ApRow" style>
                                <div
                                    class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 col-sp-12 ApColumn"
                                >
                                    <div class="block ApRawHtml">
                                        <div class="copyright">
                                            Copyright © {{ year }} penpencilbd.com. Powered by
                                            <a href="https://vthea.com" target="_blank" style="color: #fff;">
                                                <img src="/logo/vthea.png" alt="" style="height: 24px;">
                                                VThea
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- <section
                                class="product-notification leo-smart position3"
                                data-time="1000"
                                data-interval="2000"
                            >
                                <a
                                    href="javascript:void(0);"
                                    title="Close"
                                    class="close-notifi"
                                    >×</a
                                >
                                <div class="product-suggest">
                                    <label class="time-ago">
                                        Puchare By MGUERRERO 4 minutes ago
                                    </label>
                                    <div class="product-suggest-content">
                                        <a
                                            class="product-image"
                                            href="#"
                                        >
                                            <img
                                                src="https://demo74leotheme.b-cdn.net/prestashop/leo_stationero_demo/28-cart_default/the-adventure-begins-framed-poster.jpg"
                                                alt="Collins Elite Refill Week to View Manager"
                                            />
                                        </a>
                                        <div class="column-right">
                                            <a
                                                class="product-name"
                                                href="#"
                                                >Collins Elite Refill Week to
                                                View Manager</a
                                            >
                                            <p class="leo-phone">
                                                Phone: xxx0753416
                                            </p>
                                            <p class="leo-address">
                                                Address: calle 3 #3232, col
                                                estrella gustavo a madero mexico
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </section> -->
                        </div>
                    </div>
                </div>
                <!-- <svg width="0" height="0" class="hidden">
                    <symbol
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        id="shopping-cart"
                    >
                        <path
                            d="M0.795179 1.59361C0.795179 1.38144 0.879465 1.17795 1.02949 1.02792C1.17952 0.877895 1.38301 0.79361 1.59518 0.79361H2.29598C3.45918 0.79361 4.12798 1.55041 4.51518 2.30561C4.77918 2.82241 4.96958 3.45281 5.12798 4.00001H21.6C21.8472 4.00008 22.091 4.05745 22.3124 4.1676C22.5337 4.27775 22.7265 4.4377 22.8756 4.63488C23.0248 4.83207 23.1262 5.06113 23.1719 5.30409C23.2176 5.54705 23.2064 5.7973 23.1392 6.03521L20.7456 14.4752C20.5552 15.1448 20.1516 15.7341 19.5961 16.1536C19.0405 16.5732 18.3633 16.8001 17.6672 16.8H9.54078C8.83882 16.8002 8.15625 16.5697 7.59825 16.1438C7.04024 15.7179 6.63774 15.1204 6.45278 14.4432L5.42558 10.6752C5.41969 10.6583 5.41435 10.6412 5.40958 10.624L3.75998 5.02881L3.59998 4.48961C3.43998 3.93601 3.29918 3.44641 3.08798 3.03521C2.83358 2.53921 2.59998 2.39521 2.29438 2.39521H1.59358C1.38141 2.39521 1.17792 2.31092 1.02789 2.16089C0.877864 2.01087 0.793579 1.80738 0.793579 1.59521L0.795179 1.59361ZM6.95198 10.192L7.99678 14.0256C8.08941 14.364 8.29072 14.6626 8.56971 14.8754C8.8487 15.0882 9.1899 15.2034 9.54078 15.2032H17.6688C18.0167 15.2029 18.355 15.0891 18.6325 14.8792C18.9099 14.6693 19.1114 14.3747 19.2064 14.04L21.6 5.60001H5.59998L6.95198 10.1904V10.192Z"
                            fill="#01213A"
                        ></path>
                        <path
                            d="M12 20.8C12 21.4365 11.7472 22.047 11.2971 22.4971C10.847 22.9472 10.2365 23.2 9.60001 23.2C8.96349 23.2 8.35304 22.9472 7.90296 22.4971C7.45287 22.047 7.20001 21.4365 7.20001 20.8C7.20001 20.1635 7.45287 19.5531 7.90296 19.103C8.35304 18.6529 8.96349 18.4 9.60001 18.4C10.2365 18.4 10.847 18.6529 11.2971 19.103C11.7472 19.5531 12 20.1635 12 20.8ZM10.4 20.8C10.4 20.5879 10.3157 20.3844 10.1657 20.2343C10.0157 20.0843 9.81219 20 9.60001 20C9.38784 20 9.18436 20.0843 9.03433 20.2343C8.8843 20.3844 8.80001 20.5879 8.80001 20.8C8.80001 21.0122 8.8843 21.2157 9.03433 21.3657C9.18436 21.5157 9.38784 21.6 9.60001 21.6C9.81219 21.6 10.0157 21.5157 10.1657 21.3657C10.3157 21.2157 10.4 21.0122 10.4 20.8Z"
                            fill="#01213A"
                        ></path>
                        <path
                            d="M20 20.8C20 21.4365 19.7472 22.047 19.2971 22.4971C18.847 22.9472 18.2365 23.2 17.6 23.2C16.9635 23.2 16.353 22.9472 15.903 22.4971C15.4529 22.047 15.2 21.4365 15.2 20.8C15.2 20.1635 15.4529 19.5531 15.903 19.103C16.353 18.6529 16.9635 18.4 17.6 18.4C18.2365 18.4 18.847 18.6529 19.2971 19.103C19.7472 19.5531 20 20.1635 20 20.8ZM18.4 20.8C18.4 20.5879 18.3157 20.3844 18.1657 20.2343C18.0157 20.0843 17.8122 20 17.6 20C17.3878 20 17.1844 20.0843 17.0343 20.2343C16.8843 20.3844 16.8 20.5879 16.8 20.8C16.8 21.0122 16.8843 21.2157 17.0343 21.3657C17.1844 21.5157 17.3878 21.6 17.6 21.6C17.8122 21.6 18.0157 21.5157 18.1657 21.3657C18.3157 21.2157 18.4 21.0122 18.4 20.8Z"
                            fill="#01213A"
                        ></path>
                    </symbol>
                </svg> -->
            </footer>
</template>

<script setup>
import MailUs from "../nav/MailUs.vue";

const router = useRouter();

const signUpModalVisibility = ref(false);
const mailUsModalVisibility = ref(false);
const year = new Date().getFullYear();

const navigateTo = async (name) => {
    if (name.length > 0) {
        router.push({
            name: name,
        });
    }
};

const sendMail = async () => {
    mailUsModalVisibility.value = !mailUsModalVisibility.value;
};

const call = () => {
    if (process.client) {
        document.getElementById("call").click();
        
    }
};
</script>

<style lang="scss">
.input-container {
    // height: 40px;
    // border: none;

    &::placeholder {
        // font-size: 12px;
        // font-weight: 450;
    }

    &:focus {
        outline: none !important;
        box-shadow: none !important;
    }
}

.social-icons {
    a {
        width: 30px;
        height: 30px;

        i {
            color: #fff;
        }
    }

    .facebook {
        &:hover {
            background-color: #0778e8 !important;
        }

    }

    .twitter {

        &:hover {
            background-color: #5dbced !important;
        }

    }

    .instagram {

        &:hover {
            background: radial-gradient(circle farthest-corner at 35% 90%, #fec564, transparent 50%), radial-gradient(circle farthest-corner at 0 140%, #fec564, transparent 50%), radial-gradient(ellipse farthest-corner at 0 -25%, #5258cf, transparent 50%), radial-gradient(ellipse farthest-corner at 20% -50%, #5258cf, transparent 50%), radial-gradient(ellipse farthest-corner at 100% 0, #893dc2, transparent 50%), radial-gradient(ellipse farthest-corner at 60% -20%, #893dc2, transparent 50%), radial-gradient(ellipse farthest-corner at 100% 100%, #d9317a, transparent), linear-gradient(#6559ca, #bc318f 30%, #e33f5f 50%, #f77638 70%, #fec66d 100%) !important;
        }
    }

    .whatsapp {

        &:hover {
            background-color: #25D366 !important;
        }
    }
}
.payment-icons {
    
    .accept {
        img {
            cursor: pointer;
            filter: grayscale(100%);
            height: 35px !important;
            &:hover {
                filter: none;
            }
        }
    }
}

.ssl-commerz {
    
    .accept {
        img {
            cursor: pointer;
            filter: grayscale(100%);
            height: 35px !important;
            &:hover {
                filter: none;
            }
        }
    }
}

@media screen and (max-width: 700px) {
    .input-container {
        // border-radius: 0;

        &::placeholder {
            // font-size: 14px;
        }
    }

    .payment-icons {

        .accept {
            img {
                height: 45px !important;
            }
        }
    }
}
.desktop {
    display: flex;
}
.mobile {
    display: none !important;
}
@media screen and (max-width: 1023px) {
    .desktop {
        display: none !important;
    }
    .mobile {
        display: flex !important;
    } 
}
</style>
